(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frutiko-store"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-frutiko-demo]');
  if (!button) return;
  const section = button.closest('.ft');
  const demo = section.querySelector('#ft-story');
  const video = demo && demo.querySelector('video');
  if (!video) { if (demo) demo.scrollIntoView({behavior:'smooth', block:'start'}); return; }
  video.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center'});
  video.muted = false;
  const result = video.play();
  if (result && result.catch) result.catch(function() { video.focus(); });
});

// Keep the mobile shortcut away from the purchase controls already on screen.
(function(){
 const observers=new WeakMap();
 function init(root){
  const sections=root.matches&&root.matches('.ft')?[root]:root.querySelectorAll('.ft');
  for(const section of sections){
   const dock=section.querySelector('.ft-mobile-cta');if(!dock)continue;
   if(observers.has(section))observers.get(section).disconnect();
   const targets=section.querySelectorAll('.ft-product-form,.ft-duo-note');
   const visible=new Set();
   const observer=new IntersectionObserver(entries=>{
    for(const entry of entries){if(entry.isIntersecting)visible.add(entry.target);else visible.delete(entry.target);}
    dock.hidden=visible.size>0;
   },{threshold:0});
   targets.forEach(target=>observer.observe(target));observers.set(section,observer);
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll('.ft').forEach(section=>{if(observers.has(section))observers.get(section).disconnect();});});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
